<template>
  <div class="modal filter-modal promt-create-modal offer-modal">
    <div class="overlay" @click="$parent.closeOfferModal"></div>
    <div class="wrapper">
      <div class="container">
        <div>
          <div class="form-wrapper">
            <div class="form-fields">
              <div class="top">
                <div class="title title-24">
                  <b>{{ $t("Your Offer") }}</b>
                </div>
              </div>
              <div class="bottom">
                <div class="product-data">
                  <div class="img-container">
                    <img
                      v-if="$parent.activeOffer.doc_type === 'image'"
                      class="img"
                      :src="imgDomain + $parent.activeOffer.doc_url"
                    />
                    <div
                      v-else-if="$parent.activeOffer.doc_type === 'doc'"
                      class="doc-img"
                    >
                      <img src="./../assets/doc.svg" class="image" />
                    </div>
                  </div>
                  <div class="desc small">
                    <b>{{ name }}</b>
                  </div>
                </div>

                <div class="price-list">
                  <div class="col">
                    <div class="desc small">{{ $t("Your price") }}:</div>
                    <div class="input-container input-container-price">
                      <input readonly type="number" v-model="yourPrice" />
                      <div class="desc">€</div>
                    </div>
                  </div>
                  <div class="col">
                    <div class="desc small">{{ $t("Our price") }}:</div>
                    <div class="input-container input-container-price our">
                      <input readonly type="number" v-model="ourPrice" />
                      <div class="desc">€</div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="buttons">
                <button class="button" @click="decline">
                  <span>{{ $t("Decline") }}</span>
                </button>
                <button class="button blue" @click="accept">
                  <span>{{ $t("Accept") }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "OfferModal",
  props: [],
  components: {},
  data: function () {
    return {
      name: "",
      yourPrice: "",
      ourPrice: "",
      tags: [],
      verificationStatus: null,
      imgDomain: "",
    };
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    this.name = this.$parent.activeOffer.title;
    this.yourPrice = this.$parent.activeOffer.user_price;
    this.ourPrice = this.$parent.activeOffer.service_price;
    this.tags = this.$parent.activeOffer.tags;
    this.fetchVerificationStatus();
  },
  methods: {
    fetchVerificationStatus() {
      this.$http
        .get(process.env.VUE_APP_API + "user/profile")
        .then((res) => {
          this.verificationStatus = res.data.verification_data.status;
        })
        .catch((error) => {
          console.error("Error fetching verification_data:", error);
        });
    },
    decline() {
      let data = {
        id: this.$parent.activeOffer.id,
      };
      this.$http
        .post(process.env.VUE_APP_API + "offer/decline", data)
        .then(() => {
          this.$parent.closeOfferModal();
          this.$parent.openNoDealModal();
          this.$parent.getCreatedHistory();
        })
        .catch(() => {});
    },
    accept() {
      if (
        parseFloat(this.ourPrice, 3) >= parseFloat(150) &&
        this.verificationStatus !== "approved"
      ) {
        this.$parent.closeOfferModal();
        this.$parent.openVerifyModal();
      } else {
        this.$parent.openAcceptOfferModal();
      }
    },
  },
};
</script>
